import { createContext, useContext } from "react";
import { PlacementState } from "./placement-provider";
import { DetailedProviderBreakdownResponse } from "@/types/inboxPlacements.types";
import { SummaryStats } from "./placement-utils";

type PlacementContextType = {
  state: PlacementState;
  summary: SummaryStats;
  isNotCompleted: () => boolean;
  setState: React.Dispatch<React.SetStateAction<PlacementState>>;
};

export const PlacementContext = createContext<PlacementContextType | null>(
  null
);

export const usePlacementContext = () => {
  const context = useContext(PlacementContext);
  if (!context) {
    throw new Error(
      "usePlacementContext must be used within an PlacementProvider"
    );
  }
  return context;
};
